<template>
	<div class="addons--price">

		<div class="price" :class="{'price--error':!validated && hasChosenTooMuch, 'price--btn':validated}">

			<h3>Samlet pris <strong>{{stripeAmount(totalWithoutPackaging).amount}},-</strong></h3>

			<a class="btn--primary btn--sm primary--copper" href="/order" @click.prevent="placeOrder" dusk="product-done" v-if="!hasChosenTooMuch" :disabled="!validated">Bestil menu</a>

			<div class="error" v-if="!validated && hasChosenTooMuch">

				<h4>Du har valgt for meget, fjern: </h4>
				<ul>
                    <li v-for="selection in selectionQuantities" v-if="selection.optionsQuantity - order.details.quantity > 0" :dusk="selection.title + 'Remove'"><i class="fas fa-minus-circle"></i> {{selection.title}} ({{selection.optionsQuantity - order.details.quantity}} stk.)</li>
				</ul>

			</div>

		</div>

	</div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import totalCalculation from './../mixins/customTotalCalculation';
    export default {
        name: "total",
		computed:{
			...mapGetters({
                order:'order',
				product:'product',
				validated:'customSelectionsValid',
				packaging_fee:'packaging_fee',
                energy_fee:'energy_fee',

            }),
            selectionQuantities(){
			    return this.order.details.selections.map(selection => {
			        return {
			            ...selection,
                        title: this.product.selections.find(item => item.id === selection.selection_id).title,
                        optionsQuantity: selection.options.length > 0 ? selection.options.map(item => item.quantity).reduce((acc, cur) => acc + cur): 0,
			        };
                });
            },
            hasChosenTooMuch(){
			    let chosenTooMuch = false;

			    this.selectionQuantities.forEach(selection => {
			        if(selection.optionsQuantity > this.order.details.quantity){
			            chosenTooMuch = true;
                    }
                });

                return chosenTooMuch;
            }
		},
		mixins:[totalCalculation],
		methods:{
            placeOrder(){
                if(!this.validated){
                    return;
                }
                this.$store.dispatch('completedProduct');
				this.$router.push({name:'make-order.custom.order'});
            },
		},
    }
</script>

<style scoped>

</style>
